// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SignupPage.css */

.signup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: light gray-blue; /* light gray-blue */
  height: 100vh;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.signup-card {
  background-color: #0f172a; /* same as navbar */
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 400px;
  text-align: center;
  color: white;
}

.signup-card h2 {
  margin-bottom: 1.5rem;
  color: black;
  font-size: 24px;
}

.signup-card input {
  width: 100%;
  padding: 12px;
  margin-bottom: 1rem;
  border: 1px solid #334155; /* slate-700 */
  background-color: #1e293b; /* slate-800 */
  color: white;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
}

.signup-card input::placeholder {
  color: #94a3b8; /* slate-400 */
}

.signup-card input:focus {
  border-color: #3b82f6; /* Tailwind blue-500 */
  outline: none;
}

.signup-card button {
  background-color: #3b82f6;
  color: white;
  padding: 12px;
  border: none;
  border-radius: 8px;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.signup-card button:hover {
  background-color: #2563eb; /* Tailwind blue-600 */
}

.signup-page-wrapper {
  background-color: #f1f5f9;
  min-height: 100vh;
  font-family: Arial, sans-serif;
}

/* Navbar styles */
.navbar {
  background-color: #0f172a;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

.logo {
  font-size: 1.5rem;
  font-weight: bold;
}

.menu {
  list-style: none;
  display: flex;
  gap: 1.5rem;
  margin: 0;
  padding: 0;
}

.menu li a {
  text-decoration: none;
  color: white;
  font-weight: 500;
  transition: color 0.3s ease;
}

.menu li a:hover {
  color: #3b82f6; /* Tailwind blue-500 */
}

.or-separator {
  text-align: center;
  margin: 1rem 0;
  color: #64748b;
}

.google-btn {
  background-color: white;
  color: #0f172a;
  border: 1px solid #cbd5e1;
  padding: 12px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.google-btn:hover {
  background-color: #f1f5f9;
}

.signup-card {
  background-color: white;
  padding: 2rem;
  border-radius: 10px;
  width: 100%;
  max-width: 400px;
  margin: 2rem auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.signup-card input,
.signup-card button,
.signup-card .google-btn {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  box-sizing: border-box;
}

.signup-card button {
  background-color: #3b82f6;
  color: white;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.signup-card button:hover {
  background-color: #2563eb;
}

.or-separator {
  text-align: center;
  font-weight: 500;
  color: #64748b;
  margin: 0.5rem 0;
}

.google-btn {
  background-color: white;
  color: #0f172a;
  font-weight: 600;
  border: 1px solid #cbd5e1;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.google-btn:hover {
  background-color: #f3f4f6;
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;
  z-index: 1001;
}

.hamburger span {
  height: 3px;
  width: 25px;
  background-color: white;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* Responsive menu for small screens */
@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }

  .menu {
    display: none;
    flex-direction: column;
    position: absolute;
    right: 1rem;
    top: 60px;
    background-color: #0f172a;
    padding: 1rem;
    border-radius: 8px;
    z-index: 999;
  }

  .menu.menu-open {
    display: flex;
  }
}

.signup-redirect {
  margin-top: 1.5rem;
  text-align: center;
  font-size: 0.95rem;
  color: #1e293b; /* slate-800 */
}

.signup-redirect a {
  color: #3b82f6; /* Tailwind blue-500 */
  text-decoration: none;
  margin-left: 5px;
  font-weight: 500;
  transition: color 0.3s ease;
}

.signup-redirect a:hover {
  color: #2563eb; /* Tailwind blue-600 */
}

`, "",{"version":3,"sources":["webpack://./src/components/SignupPage.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC,EAAE,oBAAoB;EACvD,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAE,cAAc;EACzC,yBAAyB,EAAE,cAAc;EACzC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,qBAAqB,EAAE,sBAAsB;EAC7C,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,cAAc,EAAE,sBAAsB;EACtC,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,sBAAsB;AACxC","sourcesContent":["/* SignupPage.css */\r\n\r\n.signup-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: light gray-blue; /* light gray-blue */\r\n  height: 100vh;\r\n  padding: 20px;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.signup-card {\r\n  background-color: #0f172a; /* same as navbar */\r\n  padding: 2rem;\r\n  border-radius: 12px;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\r\n  width: 100%;\r\n  max-width: 400px;\r\n  text-align: center;\r\n  color: white;\r\n}\r\n\r\n.signup-card h2 {\r\n  margin-bottom: 1.5rem;\r\n  color: black;\r\n  font-size: 24px;\r\n}\r\n\r\n.signup-card input {\r\n  width: 100%;\r\n  padding: 12px;\r\n  margin-bottom: 1rem;\r\n  border: 1px solid #334155; /* slate-700 */\r\n  background-color: #1e293b; /* slate-800 */\r\n  color: white;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  transition: border-color 0.3s ease;\r\n}\r\n\r\n.signup-card input::placeholder {\r\n  color: #94a3b8; /* slate-400 */\r\n}\r\n\r\n.signup-card input:focus {\r\n  border-color: #3b82f6; /* Tailwind blue-500 */\r\n  outline: none;\r\n}\r\n\r\n.signup-card button {\r\n  background-color: #3b82f6;\r\n  color: white;\r\n  padding: 12px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  width: 100%;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.signup-card button:hover {\r\n  background-color: #2563eb; /* Tailwind blue-600 */\r\n}\r\n\r\n.signup-page-wrapper {\r\n  background-color: #f1f5f9;\r\n  min-height: 100vh;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n/* Navbar styles */\r\n.navbar {\r\n  background-color: #0f172a;\r\n  padding: 1rem 2rem;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  color: white;\r\n}\r\n\r\n.logo {\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.menu {\r\n  list-style: none;\r\n  display: flex;\r\n  gap: 1.5rem;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.menu li a {\r\n  text-decoration: none;\r\n  color: white;\r\n  font-weight: 500;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.menu li a:hover {\r\n  color: #3b82f6; /* Tailwind blue-500 */\r\n}\r\n\r\n.or-separator {\r\n  text-align: center;\r\n  margin: 1rem 0;\r\n  color: #64748b;\r\n}\r\n\r\n.google-btn {\r\n  background-color: white;\r\n  color: #0f172a;\r\n  border: 1px solid #cbd5e1;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.google-btn:hover {\r\n  background-color: #f1f5f9;\r\n}\r\n\r\n.signup-card {\r\n  background-color: white;\r\n  padding: 2rem;\r\n  border-radius: 10px;\r\n  width: 100%;\r\n  max-width: 400px;\r\n  margin: 2rem auto;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.signup-card input,\r\n.signup-card button,\r\n.signup-card .google-btn {\r\n  width: 100%;\r\n  padding: 12px;\r\n  font-size: 16px;\r\n  border-radius: 6px;\r\n  border: 1px solid #cbd5e1;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.signup-card button {\r\n  background-color: #3b82f6;\r\n  color: white;\r\n  font-weight: bold;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.signup-card button:hover {\r\n  background-color: #2563eb;\r\n}\r\n\r\n.or-separator {\r\n  text-align: center;\r\n  font-weight: 500;\r\n  color: #64748b;\r\n  margin: 0.5rem 0;\r\n}\r\n\r\n.google-btn {\r\n  background-color: white;\r\n  color: #0f172a;\r\n  font-weight: 600;\r\n  border: 1px solid #cbd5e1;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.google-btn:hover {\r\n  background-color: #f3f4f6;\r\n}\r\n\r\n.hamburger {\r\n  display: none;\r\n  flex-direction: column;\r\n  cursor: pointer;\r\n  gap: 5px;\r\n  z-index: 1001;\r\n}\r\n\r\n.hamburger span {\r\n  height: 3px;\r\n  width: 25px;\r\n  background-color: white;\r\n  border-radius: 2px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n/* Responsive menu for small screens */\r\n@media (max-width: 768px) {\r\n  .hamburger {\r\n    display: flex;\r\n  }\r\n\r\n  .menu {\r\n    display: none;\r\n    flex-direction: column;\r\n    position: absolute;\r\n    right: 1rem;\r\n    top: 60px;\r\n    background-color: #0f172a;\r\n    padding: 1rem;\r\n    border-radius: 8px;\r\n    z-index: 999;\r\n  }\r\n\r\n  .menu.menu-open {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n.signup-redirect {\r\n  margin-top: 1.5rem;\r\n  text-align: center;\r\n  font-size: 0.95rem;\r\n  color: #1e293b; /* slate-800 */\r\n}\r\n\r\n.signup-redirect a {\r\n  color: #3b82f6; /* Tailwind blue-500 */\r\n  text-decoration: none;\r\n  margin-left: 5px;\r\n  font-weight: 500;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.signup-redirect a:hover {\r\n  color: #2563eb; /* Tailwind blue-600 */\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
